import { Workout } from '../providers/workouts'
import { useAuth } from '../core/providers/auth'
import { useMemo } from 'react'

export const useUserHasWorkoutEditPermission = (workout?: Workout) => {
  const { admin, coach, user } = useAuth()
  return useMemo(() => {
    if (!workout) return false
    if (admin) return true
    if (coach)
      if (workout.coaches.find((coach) => coach.uid === user?.uid)) return true
    return false
  }, [workout, admin, coach, user])
}

export const useUserHasCreateWorkoutPermission = () => {
  const { admin, coach } = useAuth()
  return useMemo(() => {
    if (admin || coach) return true
    return false
  }, [admin, coach])
}
